const MOBILE_APP_STORE_URLS = {
  GAMEDAY: {
    android: 'https://play.google.com/store/apps/details?id=gr.mismatch.fans',
    ios: 'https://apps.apple.com/gr/app/mismatch-fans/id6745175454',
  },
  STATS: {
    android: 'https://play.google.com/store/apps/details?id=com.mismatch_mobile',
    ios: null,
  },
  STREAMING: {
    android: 'https://play.google.com/store/apps/details?id=com.streammanagerapp&hl=el',
    ios: 'https://apps.apple.com/us/app/mismatch-streaming/id6764303179',
  },
}

export default MOBILE_APP_STORE_URLS
